import React from 'react';
import { Breadcrumb } from 'antd';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Bread = (children: any):JSX.Element => {
    return (<Breadcrumb style={{
        margin: '16px 0 16px 0',
    }}>{children.children}</Breadcrumb>);
};

export default Bread;
